import { render, staticRenderFns } from "./RelatedArticles.vue?vue&type=template&id=0a0df13e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./RelatedArticles.vue?vue&type=script&lang=js&"
export * from "./RelatedArticles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedArticles.vue?vue&type=style&index=0&id=0a0df13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0df13e",
  null
  
)

export default component.exports